import { useState } from 'react';

import { ATSTabbedJobViewAutomationsTabTestIds } from 'data-testids/ATS';
import { AutomationContent } from './components/AutomationContent';
import { AutomationModal } from 'features/Automations/AutomationModal';
import { AutomationProvider } from 'features/Automations/context/AutomationContext';
import { AutomationsTabProps } from './types';
import { AutomationTitle } from './styles';
import { ReferenceCheckSection } from './components/ReferenceCheckSection';
import { sortAndCombineQuestionsAndAttachments } from '../QuestionsTab/utils';
import { transformOptions } from 'features/Automations/utils';
import { useQueryGetQuestionsByJobId } from '../QuestionsTab/queries';
import { Box } from '@mui/material';
import { useQueryGetAutomationsListData } from 'features/Automations/api/listQueries';
import auth from 'utils/auth';

export const AutomationsTab: React.FC<AutomationsTabProps> = ({ jobId }) => {
  const [showModal, setShowModal] = useState(false);
  const { data: questions, isLoading } = useQueryGetQuestionsByJobId(jobId);
  const sortedQuestions = questions && sortAndCombineQuestionsAndAttachments(questions);
  const transformedQuestions = transformOptions(sortedQuestions || []);
  const { data: automations } = useQueryGetAutomationsListData(jobId);
  const hasAutomations = automations?.length > 0;

  return (
    <AutomationProvider
      onClose={() => setShowModal(false)}
      open={showModal}
      questions={transformedQuestions}
      roleId={jobId}
    >
      <AutomationTitle
        data-testid={ATSTabbedJobViewAutomationsTabTestIds.AUTOMATIONS_TITLE}
        variant="h2"
      >
        Automations
      </AutomationTitle>
      <Box data-testid={ATSTabbedJobViewAutomationsTabTestIds.AUTOMATIONS_CONTENT}>
        <AutomationContent
          hasAutomations={hasAutomations}
          isLoading={isLoading}
          onOpenClick={() => setShowModal(true)}
        />
        {auth.hasAutomatedReferenceCheckFeatureFlag() && <ReferenceCheckSection jobId={jobId} />}
      </Box>
      <AutomationModal />
    </AutomationProvider>
  );
};
